import _ from "underscore";

import zipDouble from "./zip_double";

export default function getFirstValueInLists(...args) {
  const values = zipDouble(...args);
  const result = values.map(value => _.find(value, item => item[0]) ?? []);
  return result;
}
